import "./DharaFoundation.css"
import img1 from "../assets/222.png";
import img2 from "../assets/2.png";
import img3 from "../assets/3.png";
import img4 from "../assets/4.png";
import img5 from "../assets/5.png";
import gifImg from "../assets/girl.gif";
import img6 from "../assets/donate.png";
import img7 from "../assets/volunteer.png";
import { Mail, Phone, MapPin } from "lucide-react";


function DharaFoundation() {
  return (
<section className="csr">
  <div className="csr-container">

    {/* TITLE */}
    <h2 className="csr-title">धRa Foundation CSR Execution
         <img src={gifImg} alt="girl.gif" className="csr-gif" />
    </h2>

    {/* IMAGES */}
    <div className="csr-images">
      <img src={img1} alt="1" />
      <img src={img2} alt="2" />
      <img src={img3} alt="3" />
      <img src={img4} alt="4" />
      <img src={img5} alt="5" />
    </div>

  </div>

  <div className="impact">
    {/* TITLE */}
    <h2 className="impact-today">Be the change make an impact today</h2>
   

    {/* IMAGES */}
    <div className="impact-today-images">
         <div className="img-box">
      <img src={img6} alt="donate" />
      <button className="hover-btn">Donate Now</button>
      </div>

      <div className="img-box">
      <img src={img7} alt="volunteer" />
      <button className="hover-btn">Become a volunteer</button>
      </div>
      
    </div>
  </div>
</section>
  );
}

export default DharaFoundation;